import React from "react";
import './leaderboard.scss';
import Parser from "../../../common/content-parser/content-parser";
import TimeList from "../../time-list/time-list";
import ClickerAssessmentLeaderboard from "../../clicker-assessment-leaderboard/clicker-assessment-leaderboard";
import { getImageSource } from "../../../../utility/image-source";
import { ImageConstants } from "../../../../constants/constants";

class Leaderboard extends React.Component {

    constructor(props) {
        super(props);
        this.parser = new Parser();
        // this.label = this.props.quote.replace(/^(<p>(\s|&nbsp;)*<\/p>)*/, "");
        // this.label = this.label.replace(/(<p>(\s|&nbsp;)*<\/p>)*$/, "");
    }

    componentDidMount() {
        console.log(this.props.showQuestionLeaderBoard)
    }

    onClickBack() {
        this.props.delegate && this.props.delegate.hideQuestionLeaderboard && this.props.delegate.hideQuestionLeaderboard()
    }


    getQuestionLeaderBoard() {
        // console.log(this.props.leaderboardData, this.props.leaderboardLimit)

        let leaderboardData = this.props.leaderboardData
        let isQualified = false, isFinalQuestion = false

        let limit = this.props.leaderboardLimit === '5' ? 5 : this.props.leaderboardLimit === '10' ? 10 : this.props.leaderboardLimit === 'ALL' ? this.props.leaderboardData.length ? this.props.leaderboardData.length : 100 : 100

        // if ((this.props.activePage === this.props.questions.length) && this.props.showQuestionLeaderBoard) {
        // leaderboardData = this.props.leaderboardData.slice(0, limit)
        //     isFinalQuestion = true
        // }

        if (this.props.leaderboardData.length) {
            leaderboardData = this.props.leaderboardData.slice(0, limit)
        }

        return (<div>
            {/* <div className="text-center">Overall Leaderboard</div> */}
            <ClickerAssessmentLeaderboard leaderboardLimit={this.props.leaderboardLimit}
                leaderboardData={leaderboardData} isQualified={isQualified} isFinalQuestion={isFinalQuestion} />
        </div>)
    }



    render() {
        let styles = {
            p: { fontSize: '28px', fontFamily: "Mont", fontStyle: 'normal', fontWeight: "700" }
        }

        console.log(this.props.showLargeStudentResponseSideBar)


        return (
            <div className="leaderboard" style={{
                marginLeft: `${this.props.isFullScreenMode && this.props.showStudentResponse ? this.props.showLeaderboard || this.props.showLargeStudentResponseSideBar ? "0.5rem" : '14rem' :
                    this.props.isFullScreenMode && !this.props.showStudentResponse ? "0.5rem" : this.props.showStudentResponse ? "6rem" : '0rem'}`
            }}>
                {
                    this.props.showLeaderboard ?
                        <div className="d-flex align-items-center mb-1">
                            {/* <img className="countingwell-logo mr-2" src={getImageSource(ImageConstants.CW_LOGO_NEW)} /> */}
                            {/* <div className="quiz-button mr-2">Practice</div> */}
                            {/* <div className="subject-text">India Maths Day 2024</div> */}
                            {/* <div className="subject-text">{this.props.chapterTitle}</div> */}
                            {
                                this.props.showBackButton ?
                                    
                                        <div className="mr-2"><img className='close-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} /></div>
                                    
                                    :
                                    <></>
                            }
                            {/* <div className="question-number ml-2">Q {this.props.activePage}/{this.props.totalQuestions}</div> */}
                            {
                                this.props.showQuestionLeaderBoard ? <div className="leaderboard-text">Overall Rank
                                {` (${this.props.leaderboardLimit === '5' ? 'Top 5 Students' : this.props.leaderboardLimit === '10' ? 'Top 10 Students' : this.props.leaderboardLimit === 'ALL' ? 'All Students' : ''})`}</div> :
                                 <div className="leaderboard-text">Question Rank
                                 {` (${this.props.leaderboardLimit === '5' ? 'Top 5 Students' : this.props.leaderboardLimit === '10' ? 'Top 10 Students' : this.props.leaderboardLimit === 'ALL' ? 'All Students' : ''})`}</div>
                            }
                        </div>
                        :
                        <div className="d-flex align-items-center mb-3">
                            <div className="quiz-button mr-2">Assessment</div>
                            {/* <div className="subject-text">Science</div> */}
                            {/* <div className="question-number ml-2">Q {this.props.activePage}/{this.props.questions && this.props.questions.length ? this.props.questions.length : this.props.totalQuestions}</div> */}
                            {
                                this.props.showQuestionLeaderBoard ? <div className="leaderboard-text">Leader Board</div> : ""
                            }
                        </div>
                }
                {
                    this.props.showLeaderboard ?
                        this.props.showQuestionLeaderBoard ?
                            <>{this.getQuestionLeaderBoard()}</>
                            :
                            <div className="">
                                <TimeList leaderboardLimit={this.props.leaderboardLimit} timeListHash={this.props.timeListHash} studentListHash={this.props.studentListHash} />
                            </div>
                        :
                        <></>
                }
            </div>
        )
    }

}

export default Leaderboard;